/**
 * @description 联系我们 API
 */
const prefix = process.env.VUE_APP_API_DATAS
const prefix2 = process.env.VUE_APP_API
export default ({ request }) => ({
  // 联系方式
  contact(params = {}) {
    return request({
      url: `${prefix}/contact`,
      method: 'get',
      params
    })
  },
  // 人才招聘
  hr(params = {}) {
    return request({
      url: `${prefix}/hr`,
      method: 'get',
      params
    })
  },
  // 在线留言
  message(data = {}) {
    return request({
      url: `${prefix2}/message`,
      method: 'post',
      data
    })
  },
})